import { render, staticRenderFns } from "./MonthlyHistory.vue?vue&type=template&id=1197e94b&"
import script from "./MonthlyHistory.vue?vue&type=script&lang=js&"
export * from "./MonthlyHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports